import type { FaireProductEntity } from "../../entity_types/product";

export const p_6tygza284u: FaireProductEntity = {
  token: "p_6tygza284u",
  type: "product",
  name: "Custom Crewneck Sweatshirt, Custom State & City Sweatshirt",
  brandToken: "b_6zj4dcu23e",
  brandName: "Threads And Needles, INC.",
  imageUrl:
    "https://cdn.faire.com/fastly/95cfb33ef3aba58b18480245d6f5ace973f3621c14d3b554de65968cf2b758e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0882b24705776c5b6b285dc4151b6699d0d3f810cf845b69dec532d2f8cc0493.jpeg",
    "https://cdn.faire.com/fastly/f4953715228ea0d18ca0506231d69c6695b4e25ddf158b3fa84e41ed42592687.png",
    "https://cdn.faire.com/fastly/8952eef54c5e32176e5f879c2babfa26d8376a80702db2ea18dbd0a19fed3eed.png",
    "https://cdn.faire.com/fastly/c5183a46ac68511df7540e5975bfdb9c3303eda6a27bee70955aba9ab44a3a7d.png",
  ],
  priceDollars: 34.64,
  description:
    "We can customize sweatshirts designed to your specific needs! Team names, your city/town name, company names, events, parties - we can do it for you! \n\n- Important: we can customize up to 9 letters maximum only per line. No letters or special characters. If you would like us to customize a text for you with more than 9 letters, kindly message us first to see if it's possible. \n- Our varsity letters are embroidered patches that have been ironed on and heat pressed, not embroidered. But reassured they won't come off even after wash.\n- Material: 50% Cotton, 50% Polyester\n- Our sweatshirt material is super soft and comfy! \n- All our sweatshirts run a unisex fit. They are naturally oversized, so we normally recommend your true size. But if you like a more baggy look, we recommend sizing up.\n\nThank you so much for supporting our small business here in Chicago! It means the world to us. Let us know if you have questions.\n\nTags: Custom Sweatshirt, Custom Crewneck, Custom Gifts, Custom Sweater, Custom Hoodie,  Custom City Sweatshirt, Custom State Sweatshirt, Custom Team Sweatshirt, Custom School Sweatshirt, Custom Spirit Sweatshirt, Personalizable Sweatshirt",
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:43.037Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
